export default "__VITE_ASSET__gR8169qd__"